/*
 * @Author: ken yang
 * @Date: 2026-03-03
 * @LastEditTime: 2026-03-03
 * @LastEditors: ken yang
 * @Description: ECO 活动相关接口 (遵循项目标准 API 格式，全面使用 VueUse)
 * @FilePath: /uexch_h5/src/api/eco.js
 */
import { useReq } from '@/utils/request/useReq'

// 推荐模块信息 (POST /supernode/v2/invite/info)
const inviteInfoUrl = '/supernode/v2/invite/info'
const getInviteInfo = (params = {}, options = {}) =>
  useReq(inviteInfoUrl, { method: 'POST', data: params }, options)

// 推荐奖励比例 (POST /supernode/v2/invite/reward-ratios)
const rewardRatiosUrl = '/supernode/v2/invite/reward-ratios'
const getRewardRatios = (params = {}, options = {}) =>
  useReq(rewardRatiosUrl, { method: 'POST', data: params }, options)

// 绑定邀请关系 (POST /supernode/v2/invite/bind)
const bindInviteUrl = '/supernode/v2/invite/bind'
const bindInvite = (params = {}, options = {}) =>
  useReq(bindInviteUrl, { method: 'POST', data: params }, { immediate: false, ...options })

// 获取个人返佣邀请信息 (POST /user/invite/info)
const rebateInviteInfoUrl = '/user/invite/info'
const getRebateInviteInfo = (params = {}, options = {}) =>
  useReq(rebateInviteInfoUrl, { method: 'POST', data: params }, options)

// 基金认购页信息 (POST /supernode/v2/fund/info)
const fundInfoUrl = '/supernode/v2/fund/info'
const getFundInfo = (params = {}, options = {}) =>
  useReq(fundInfoUrl, { method: 'POST', data: params }, options)

// 动力基金信息 (POST /supernode/v2/momentum/info)
const momentumInfoUrl = '/supernode/v2/momentum/info'
const getMomentumInfo = (params = {}, options = {}) =>
  useReq(momentumInfoUrl, { method: 'POST', data: params }, options)

// ECO 质押信息 (POST /supernode/v2/staking/info)
const stakingInfoUrl = '/supernode/v2/staking/info'
const getStakingInfo = (params = {}, options = {}) =>
  useReq(stakingInfoUrl, { method: 'POST', data: params }, options)

// ECO 质押 (POST /supernode/v2/staking/stake)
const stakeUrl = '/supernode/v2/staking/stake'
const stake = (params = {}, options = {}) =>
  useReq(stakeUrl, { method: 'POST', data: params }, { immediate: false, ...options })

// 推荐业绩总览 (POST /supernode/v2/invite/recommend-overview)
const recommendOverviewUrl = '/supernode/v2/invite/recommend-overview'
const getRecommendOverview = (params = {}, options = {}) =>
  useReq(recommendOverviewUrl, { method: 'POST', data: params }, options)

// 团队业绩总览 (POST /supernode/v2/invite/team-performance-overview)
const teamPerformanceOverviewUrl = '/supernode/v2/invite/team-performance-overview'
const getTeamPerformanceOverview = (params = {}, options = {}) =>
  useReq(teamPerformanceOverviewUrl, { method: 'POST', data: params }, options)

// 推荐业绩明细 (POST /supernode/v2/invite/recommend-records)
const recommendRecordsUrl = '/supernode/v2/invite/recommend-records'
const getRecommendRecords = (params = {}, options = {}) =>
  useReq(recommendRecordsUrl, { method: 'POST', data: params }, options)

// 奖励中心待领取 (POST /supernode/v2/reward/pending)
const rewardPendingUrl = '/supernode/v2/reward/pending'
const getRewardPending = (params = {}, options = {}) =>
  useReq(rewardPendingUrl, { method: 'POST', data: params }, options)

// 拉新奖励明细 (POST /supernode/v2/reward/momentum-records)
const momentumRewardRecordsUrl = '/supernode/v2/reward/momentum-records'
const getMomentumRewardRecords = (params = {}, options = {}) =>
  useReq(momentumRewardRecordsUrl, { method: 'POST', data: params }, options)

// 资产概览 (POST /supernode/v2/reward/asset-overview)
const assetOverviewUrl = '/supernode/v2/reward/asset-overview'
const getAssetOverview = (params = {}, options = {}) =>
  useReq(assetOverviewUrl, { method: 'POST', data: params }, options)

// 领取奖励 (POST /supernode/v2/reward/claim)
const claimRewardUrl = '/supernode/v2/reward/claim'
const claimReward = (params = {}, options = {}) =>
  useReq(claimRewardUrl, { method: 'POST', data: params }, { immediate: false, ...options })

// 算力抢购页信息 (POST /supernode/v2/hashrate/info)
const hashrateInfoUrl = '/supernode/v2/hashrate/info'
const getHashrateInfo = (params = {}, options = {}) =>
  useReq(hashrateInfoUrl, { method: 'POST', data: params }, options)

// 基金持仓数据 (POST /supernode/v2/fund/positions)
const fundPositionsUrl = '/supernode/v2/fund/positions'
const getFundPositions = (params = {}, options = {}) =>
  useReq(fundPositionsUrl, { method: 'POST', data: params }, options)

// 动力持仓数据 (POST /supernode/v2/momentum/positions)
const momentumPositionsUrl = '/supernode/v2/momentum/positions'
const getMomentumPositions = (params = {}, options = {}) =>
  useReq(momentumPositionsUrl, { method: 'POST', data: params }, options)

// ECO 质押持仓 (POST /supernode/v2/staking/positions)
const stakingPositionsUrl = '/supernode/v2/staking/positions'
const getStakingPositions = (params = {}, options = {}) =>
  useReq(stakingPositionsUrl, { method: 'POST', data: params }, options)

// ECO 质押赎回 (POST /supernode/v2/staking/redeem)
const redeemStakingUrl = '/supernode/v2/staking/redeem'
const redeemStaking = (params = {}, options = {}) =>
  useReq(redeemStakingUrl, { method: 'POST', data: params }, { immediate: false, ...options })

// 算力释放汇总 (POST /supernode/v2/hashrate/release-summary)
const hashrateReleaseSummaryUrl = '/supernode/v2/hashrate/release-summary'
const getHashrateReleaseSummary = (params = {}, options = {}) =>
  useReq(hashrateReleaseSummaryUrl, { method: 'POST', data: params }, options)

// 赎回基金 (POST /supernode/v2/fund/redeem)
const redeemFundUrl = '/supernode/v2/fund/redeem'
const redeemFund = (params = {}, options = {}) =>
  useReq(redeemFundUrl, { method: 'POST', data: params }, { immediate: false, ...options })

// 抢购算力 (POST /supernode/v2/hashrate/subscribe)
const subscribeHashrateUrl = '/supernode/v2/hashrate/subscribe'
const subscribeHashrate = (params = {}, options = {}) =>
  useReq(subscribeHashrateUrl, { method: 'POST', data: params }, { immediate: false, ...options })

// 算力领取 (POST /supernode/v2/hashrate/claim)
const claimHashrateUrl = '/supernode/v2/hashrate/claim'
const claimHashrate = (params = {}, options = {}) =>
  useReq(claimHashrateUrl, { method: 'POST', data: params }, { immediate: false, ...options })

// 基金认购 (POST /supernode/v2/fund/subscribe)
const subscribeFundUrl = '/supernode/v2/fund/subscribe'
const subscribeFund = (params = {}, options = {}) =>
  useReq(subscribeFundUrl, { method: 'POST', data: params }, { immediate: false, ...options })

// 动力基金认购 (POST /supernode/v2/momentum/subscribe)
const subscribeMomentumUrl = '/supernode/v2/momentum/subscribe'
const subscribeMomentum = (params = {}, options = {}) =>
  useReq(subscribeMomentumUrl, { method: 'POST', data: params }, { immediate: false, ...options })

// 需要登录的 URL 白名单
const needLoginUrl = [inviteInfoUrl, fundInfoUrl, momentumInfoUrl, stakingInfoUrl, stakeUrl, subscribeFundUrl, subscribeMomentumUrl, rewardRatiosUrl, bindInviteUrl, rebateInviteInfoUrl, recommendOverviewUrl, teamPerformanceOverviewUrl, recommendRecordsUrl, rewardPendingUrl, momentumRewardRecordsUrl, assetOverviewUrl, claimRewardUrl, hashrateInfoUrl, subscribeHashrateUrl, fundPositionsUrl, momentumPositionsUrl, stakingPositionsUrl, redeemStakingUrl, redeemFundUrl, hashrateReleaseSummaryUrl, claimHashrateUrl]

export const ecoApi = {
  getInviteInfo,
  getRewardRatios,
  bindInvite,
  getRebateInviteInfo,
  getMomentumInfo,
  getStakingInfo,
  getRecommendOverview,
  getTeamPerformanceOverview,
  getRecommendRecords,
  getRewardPending,
  getMomentumRewardRecords,
  getAssetOverview,
  claimReward,
  getHashrateInfo,
  subscribeHashrate,
  getHashrateReleaseSummary,
  claimHashrate,
  getFundInfo,
  getFundPositions,
  getMomentumPositions,
  getStakingPositions,
  redeemStaking,
  redeemFund,
  stake,
  subscribeFund,
  subscribeMomentum,
  needLoginUrl
}

export default ecoApi
